import { render, staticRenderFns } from "./ProdutoAdicionar.vue?vue&type=template&id=28f12c00&scoped=true&"
import script from "./ProdutoAdicionar.vue?vue&type=script&lang=js&"
export * from "./ProdutoAdicionar.vue?vue&type=script&lang=js&"
import style0 from "./ProdutoAdicionar.vue?vue&type=style&index=0&id=28f12c00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f12c00",
  null
  
)

export default component.exports